import { Box, BoxProps, styled } from '@mui/material';
import { ReactElement } from 'react';

export type PoolCardHeaderProps = BoxProps;

const StyledBox = styled(Box)(({ theme }) => ({
    ...theme.typography['subtitle1'],
    position: 'relative',
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(1),
}));

export const PoolCardHeader = (props: PoolCardHeaderProps): ReactElement => {
    return <StyledBox {...props} />;
};
